import {
  TREASURY_FIELD_TYPE_LABELS,
  TREASURY_FIELD_USAGE_LABELS,
  TREASURY_FORM_STATUSES,
  TREASURY_FORM_TYPE_OPTIONS,
  TREASURY_MOVEMENT_TYPE_LABELS,
  TREASURY_SUBMISSION_STATUS_LABELS,
} from "../constants/treasuryFormsOptions";

export function getFormTypeLabel(type) {
  if (!type) return "—";
  const found = TREASURY_FORM_TYPE_OPTIONS.find(
    (opt) => opt.value === String(type).toUpperCase()
  );
  return found ? found.label : type;
}

export function getFormStatusLabel(status) {
  if (!status) return "—";
  return status === TREASURY_FORM_STATUSES.ARCHIVED ? "Archivado" : "Activo";
}

export function getFormStatusFilterLabel(status) {
  if (!status) return "Todos los estados";
  return getFormStatusLabel(status);
}

export function getSubmissionStatusLabel(status) {
  if (!status) return "—";
  return TREASURY_SUBMISSION_STATUS_LABELS[status] || status;
}

export function getFieldTypeLabel(fieldType) {
  if (!fieldType) return "—";
  return TREASURY_FIELD_TYPE_LABELS[fieldType] || fieldType;
}

export function getFieldUsageLabel(usage) {
  if (!usage) return "—";
  return TREASURY_FIELD_USAGE_LABELS[usage] || usage;
}

export function getMovementTypeLabel(movementType) {
  if (!movementType) return "—";
  return TREASURY_MOVEMENT_TYPE_LABELS[movementType] || movementType;
}

export function formatCalendarDate(iso) {
  if (!iso) return "—";

  if (typeof iso === "string") {
    const trimmed = iso.trim();
    const match = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (match) {
      const [, yyyy, mm, dd] = match;
      return `${dd}/${mm}/${yyyy}`;
    }
  }

  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";

  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();

  return `${dd}/${mm}/${yyyy}`;
}

export function formatDate(iso) {
  return formatCalendarDate(iso);
}

export function formatDateTime(iso) {
  if (!iso) return "—";

  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";

  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  const hh = String(d.getHours()).padStart(2, "0");
  const min = String(d.getMinutes()).padStart(2, "0");

  return `${dd}/${mm}/${yyyy} ${hh}:${min}`;
}

export function formatCurrency(amount, currency = "ARS") {
  const num = Number(amount);
  if (Number.isNaN(num)) return "$ 0,00";

  const formatted = new Intl.NumberFormat("es-AR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);

  return `$ ${formatted}${currency && currency !== "ARS" ? ` ${currency}` : ""}`;
}

export function formatBytes(bytes) {
  const size = Number(bytes);
  if (!size || isNaN(size) || size <= 0) return "0 B";
  const units = ["B", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(size) / Math.log(1024));
  return `${(size / Math.pow(1024, i)).toFixed(i === 0 ? 0 : 1)} ${units[i] || "B"}`;
}

